import { generateUUID, hasValue } from "../../../../util";
import { ICustomJsonDataSource, IDataSource } from "../datasource";

export function newJsonSource(): ICustomJsonDataSource {
    return {
        id: '',
        parameters: [],
        description: 'Custom JSON data as a source',
        name: 'CJD-' + generateUUID(),
        type: 'custom-json',
        json: {},
        __source__: null
    }
}

// "# Available Fields" markdown block — copied verbatim from the canvas
// DataSourceBrowser so the Docs carried on the initSource match byte-for-byte.
export function buildFieldsDoc(attributes: any[]): string {
    let docs = '';
    docs += '# Available Fields\r\n';
    docs += 'The following fields are available in this collection:\r\n';
    for (let attr of attributes || []) {
        let { name, dataType } = attr;
        docs += `* ${name} - ${dataType || 'text'}\r\n`;
    }
    return docs;
}

// ---- preview helpers ----------------------------------------------------
// Coerce whatever executeAndBind returns (array / object / scalar) into rows.
export function normalizeRows(result: any): any[] {
    if (Array.isArray(result)) return result.filter(r => r != null);
    if (result && typeof result === 'object') return [result];
    return [];
}

function dummyValue(type: string, i: number): any {
    switch (type) {
        case 'number':
        case 'integer': return i + 1;
        case 'boolean': return i % 2 === 0;
        default: return `Sample ${i + 1}`;
    }
}

// Canvas parity (simplified): synthesize up to 5 rows from the output schema when
// live data is empty/unavailable. array → items.properties; object → properties.
export function synthPlaceholderRows(schema: any): any[] {
    let properties: any = null;
    if (schema?.type === 'array') properties = schema?.items?.properties;
    else if (schema?.type === 'object') properties = schema?.properties;
    const keys = Object.keys(properties || {});
    if (!keys.length) return [];
    const rows: any[] = [];
    for (let i = 0; i < 5; i++) {
        const row: any = {};
        for (const k of keys) row[k] = dummyValue(properties[k]?.type, i);
        rows.push(row);
    }
    return rows;
}

export function previewName(src: IDataSource | null): string {
    if (!src) return 'Preview';
    const s = src as any;
    if (hasValue(s.name)) return s.name;
    if (src.type === 'model-action' || src.type === 'model-collection' || src.type === 'external-database') {
        return `${s.model}.${s.action}`;
    }
    return src.type;
}

export function stringifyCell(v: any): string {
    if (v == null) return '';
    if (typeof v === 'object') return JSON.stringify(v);
    return String(v);
}
